import React, { useState, useLayoutEffect } from 'react';
import { StyleSheet, View, SafeAreaView, ScrollView } from 'react-native';

import InputForm from '../components/InputForm';
import { leftMenuHeaderOption, rightUserHeaderOption } from '../utils/defaultNavOptions';

import { CommonStyles, CommonProperties, Color } from '../styles';
import { Modals } from '../constants/ScreenNames';
import MultipleSelect from '../components/SegmentedControl/MultipleSelect';
import RowView from '../components/RowView';
import BaseText from '../components/BaseText';
import Button, { BUTTON_TYPES } from '../components/Button';
import Icon from '../components/Icon';
import { scale } from '../utils/scale.utils';
import FloatButton from '../components/FloatButton';
import { TouchableOpacity } from 'react-native-gesture-handler';
import SwithcWithLabel from '../components/SwitchWithLabel';
import Modal from '../components/Modal';
import UserItem from '../components/TripHub/Social/UserItem';

const NoConnection = ({ onPress }) => {
  return (
    <View
      style={{
        width: '100%',
        ...CommonProperties.px3,
        ...CommonProperties.centerAlignment,
        ...CommonProperties.mt5,
      }}
    >
      <BaseText style={CommonStyles.h1}>No Connections</BaseText>
      <BaseText style={[CommonStyles.h3, { textAlign: 'center' }]}>
        Invite your friends and collegues for great discounts
      </BaseText>
      <Button
        label="Add Connection"
        style={[
          CommonStyles.borderRadius4,
          CommonStyles.shadow,
          { width: '100%', alignItems: 'center', ...CommonProperties.mt5 },
        ]}
        labelStyle={[CommonStyles.h2, CommonStyles.flex1]}
        onPress={onPress}
      />
      <Icon
        size={124}
        name="people"
        style={{ opacity: 0.3, color: Color.grayText, marginTop: scale(42) }}
      />
    </View>
  );
};

const Modal1 = ({ visible, onClose }) => {
  return (
    <Modal visible={visible} transparent>
      <View style={stylesModal.wrap}>
        <View style={stylesModal.innerWrap}>
          <View style={stylesModal.cancel}>
            <TouchableOpacity onPress={onClose}>
              <Icon name="cancel" color={Color.primary} size={24} />
            </TouchableOpacity>
          </View>
          <BaseText style={stylesModal.title}>Connection Request</BaseText>
          <BaseText style={stylesModal.subtitle}>Would you like to share</BaseText>
          <View style={[CommonStyles.justifyCenter, CommonStyles.my3]}>
            <SwithcWithLabel left={true} label="Trip Details" />
            <SwithcWithLabel left={true} label="Active Events" />
          </View>
          <Button
            label="Connect"
            onPress={onClose}
            style={[CommonStyles.py2, { flex: 1, width: '100%', borderRadius: 24 }]}
            labelStyle={[{ fontSize: 20 }]}
          />
        </View>
      </View>
    </Modal>
  );
};

const Modal2 = ({ visible, onClose }) => {
  return (
    <Modal visible={visible} transparent>
      <View style={stylesModal.wrap}>
        <View style={stylesModal.innerWrap}>
          <View style={stylesModal.cancel}>
            <TouchableOpacity onPress={onClose}>
              <Icon name="cancel" color={Color.primary} size={24} />
            </TouchableOpacity>
          </View>
          <BaseText style={stylesModal.title}>Accept Request</BaseText>
          <BaseText style={stylesModal.subtitle}>You can choose to share your:</BaseText>
          <View style={[CommonStyles.justifyCenter, CommonStyles.my3]}>
            <SwithcWithLabel left={true} label="Trip Details" />
            <SwithcWithLabel left={true} label="Active Events" />
          </View>
          <Button
            label="Accept"
            onPress={onClose}
            style={[CommonStyles.py2, { flex: 1, width: '100%', borderRadius: 24 }]}
            labelStyle={[{ fontSize: 20 }]}
          />
          <Button
            label="Decline Request"
            type={BUTTON_TYPES.TEXT}
            onPress={onClose}
            style={[
              CommonStyles.py2,
              CommonStyles.mt3,
              { flex: 1, width: '100%', borderRadius: 24 },
            ]}
            labelStyle={[{ fontSize: 20 }]}
          />
        </View>
      </View>
    </Modal>
  );
};

const users = [
  {
    type: 0,
    name: 'Steve K.',
    desc: 'Coworker',
  },
  {
    type: 0,
    name: 'Robert Downey',
    desc: 'Coworker',
  },
  {
    type: 0,
    name: 'Nicolas Cage',
    desc: 'Coworker',
  },
  {
    type: 0,
    name: 'Pedro Pascal',
    desc: 'Coworker',
  },
  {
    type: 0,
    name: 'Brad Pitt',
    desc: 'Coworker',
  },
  {
    type: 1,
    name: 'Alejandro Perez',
    desc: 'Coworker',
  },
  {
    type: 2,
    name: 'Leonardo DiCaprio',
    desc: 'Coworker',
  },
  {
    type: 3,
    name: 'Quentin Tarantino',
    desc: 'Pending Request',
  },
  {
    type: 1,
    name: 'Bruce Willis',
    desc: 'Coworker',
  },
  {
    type: 2,
    name: 'Steve K.',
    desc: 'Coworker',
  },
];

const SocialScreen = (props) => {
  const filters = [
    {
      label: 'Coworkes',
      value: 'Coworkes',
    },
    {
      label: 'PointPals',
      value: 'PointPals',
    },
    {
      label: 'Groups',
      value: 'Groups',
    },
    {
      label: 'Connections',
      value: 'Connections',
    },
  ];

  const [searchValue, setSearchValue] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  useLayoutEffect(() => {
    props.navigation.setOptions({
      headerTitle: () => (
        <InputForm
          value={searchValue}
          placeholder={'Find Connections'}
          style={CommonStyles.mb0}
          clearButtonMode="always"
          onChangeText={(text) => {
            setSearchValue(text);
          }}
        />
      ),
      headerTitleAlign: 'left',
      ...rightUserHeaderOption(() => {
        props.navigation.navigate(Modals.AddConnectionModal);
      }),
      ...leftMenuHeaderOption(props),
    });
  }, [props, setSearchValue, searchValue]);

  const sendConnectionRequest = () => {
    setShowModal(true);
  };
  const acceptConnectionRequest = () => {
    setShowAcceptModal(true);
  };
  const showUserProfile = () => {
    props.navigation.navigate(Modals.UserProfileModal, { name: 'Robert Newman' });
    // TODO:
  };

  return (
    <SafeAreaView style={styles.pageContainer}>
      <Modal1 onClose={() => setShowModal(false)} visible={showModal} />
      <Modal2 onClose={() => setShowAcceptModal(false)} visible={showAcceptModal} />
      {users && users.length > 0 ? (
        <MultipleSelect
          items={filters}
          onChange={(value) => setFilterStatus(value)}
          selected={filterStatus}
        />
      ) : null}
      <ScrollView style={[CommonStyles.flex1, CommonStyles.py3]}>
        <RowView style={styles.container}>
          {users
            ? users.map((user, index) => (
                <UserItem
                  key={index}
                  name={user.name}
                  desc={user.desc}
                  onPress={() => {
                    switch (user.type) {
                      case 0:
                        return sendConnectionRequest();
                      case 1:
                        return;
                      case 2:
                        return showUserProfile();
                      case 3:
                        return acceptConnectionRequest();
                    }
                  }}
                  image={
                    index % 3 === 0
                      ? `https://randomuser.me/api/portraits/men/${Math.floor(
                          Math.random() * 100
                        )}.jpg`
                      : false
                  }
                  type={user.type}
                />
              ))
            : null}
          {!users || users.length === 0 ? (
            <NoConnection
              onPress={() => {
                props.navigation.navigate(Modals.AddConnectionModal);
              }}
            />
          ) : null}
        </RowView>
      </ScrollView>
      <FloatButton
        onPress={() => {
          props.navigation.navigate(Modals.AddConnectionModal);
        }}
        iconName={'addPerson'}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
    backgroundColor: 'white',
  },
  container: {
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
});

const stylesModal = StyleSheet.create({
  wrap: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,.5)',
    ...CommonProperties.centerAlignment,
    ...CommonProperties.p5,
  },
  innerWrap: {
    width: '100%',
    backgroundColor: 'white',
    ...CommonProperties.p3,
    ...CommonProperties.borderRadius2,
    ...CommonProperties.centerItems,
    ...CommonProperties.py5,
  },
  subtitle: {
    color: Color.text.medium,
    ...CommonProperties.h3,
    ...CommonProperties.px5,
    textAlign: 'center',
  },
  title: {
    color: Color.primary,
    ...CommonProperties.h1,
    ...CommonProperties.mt5,
    ...CommonProperties.mb3,
  },
  border: {
    borderTopColor: Color.text.low,
    borderTopWidth: 1,
    width: '100%',
    ...CommonProperties.my5,
  },
  details: {
    ...CommonProperties.pb5,
    ...CommonProperties.mt2,
  },
  date: {
    ...CommonProperties.h3,
    ...CommonProperties.mr5,
  },
  cancel: {
    position: 'absolute',
    top: scale(14),
    right: scale(12),
  },
});

export default SocialScreen;
